import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing, containers } = lightTheme;

const titleBaseStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: spacing(0.5),
  a: {
    color: palette.primary.main,
    textDecoration: 'none'
  },
  li: {
    color: palette.primary.main,
    '::marker': {
      color: palette.primary.main
    }
  },
  '&:not(:first-of-type)': {
    marginTop: spacing(0.5)
  }
};

const styles: Record<string, SxProps> = {
  container: {
    ...containers.type2
  },

  bulletPoint: {
    borderRadius: '50%',
    background: palette.primary.main,
    width: '0.4rem',
    height: '0.4rem'
  },

  subsection: {
    marginTop: spacing(2)
  },

  internalBox: {
    ...containers.type1,
    border: `0.063rem solid ${palette.secondary['600']}`,
    borderRadius: '0.5rem'
  },

  title: {
    color: palette.primary.main,
    textDecoration: 'none',
    marginBottom: spacing(1)
  },

  subtitle: {
    ...titleBaseStyles
  },

  tertiarytitle: {
    ...titleBaseStyles,
    marginLeft: spacing(2)
  },

  fourthtitle: {
    ...titleBaseStyles,
    marginLeft: spacing(3)
  }
};

export default styles;
